
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import es      from 'vuetify/lib/locale/es'
import 'vuetify/dist/vuetify.min.css'
Vue.use(Vuetify)
const opciones = {
  icons: { iconfont: 'md' },
  theme: {
    themes: {
      light : {
        primary   : '#b80813',
        secondary : '#f7e2e3',
        error     : '#f14668',
        background: '#ebeff3',
        success   : '#48c78e',
        opacity   : '#b80813cc',
        dark      : '#2d4258'
      },
      dark : {
        primary   : '#b80813',
        secondary : '#441115',
        error     : '#f14668',
        background: '#272727',
        success   : '#48c78e',
        opacity   : '#b80813cc'
      }
    }
  },
  lang : {
    locales: { es },
    current: 'es'
  }
}

export default new Vuetify(opciones)



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js